import { initializeApp } from "firebase/app";
import {
  connectAuthEmulator,
  getAuth,
  OAuthProvider,
} from "firebase/auth";

import { ENV } from "./env";

export const FIREBASE_APP = initializeApp({
  apiKey: ENV.FIREBASE.API_KEY,
  authDomain: ENV.FIREBASE.AUTH_DOMAIN,
  projectId: ENV.FIREBASE.PROJECT_ID,
  appId: ENV.FIREBASE.APP_ID,
});

export const FIREBASE_AUTH = getAuth(FIREBASE_APP);

if (ENV.FIREBASE_AUTH_EMULATOR_HOST) {
  connectAuthEmulator(
    FIREBASE_AUTH,
    `http://${ENV.FIREBASE_AUTH_EMULATOR_HOST}`,
    { disableWarnings: true },
  );
}

export function buildMicrosoftProvider(): OAuthProvider {
  const provider = new OAuthProvider("microsoft.com");
  provider.addScope("email");
  provider.addScope("openid");
  provider.addScope("profile");
  if (ENV.MS_TENANT_ID) {
    provider.setCustomParameters({ tenant: ENV.MS_TENANT_ID });
  }
  return provider;
}
